module.exports = __webpack_public_path__ + "build/img/booklet-example-2.6d12fbe6.jpg";